import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { duplicateCollectionItem, moveCollectionItem } from "./collectionItems";

interface ICollectionItemActions<T> {
  compact?: boolean;
  items: T[];
  index: number;
  onChange: (items: T[]) => void;
}

const CollectionItemActions = <T extends { Id: number | string },>({ items, index, onChange, compact = false }: ICollectionItemActions<T>) => (
  <span className={`d-inline-flex gap-1${compact ? "" : " flex-wrap ms-1"}`}>
    <Button size="sm" variant="outline-secondary" title="Duplicate item" aria-label="Duplicate item" onClick={() => onChange(duplicateCollectionItem(items, index))}>{compact ? <FontAwesomeIcon icon={faCopy} /> : "Duplicate"}</Button>
    <Button size="sm" variant="outline-secondary" title="Move item earlier" aria-label="Move item earlier" disabled={index === 0}
      onClick={() => onChange(moveCollectionItem(items, index, -1))}>↑</Button>
    <Button size="sm" variant="outline-secondary" title="Move item later" aria-label="Move item later" disabled={index === items.length - 1}
      onClick={() => onChange(moveCollectionItem(items, index, 1))}>↓</Button>
  </span>
);
export default CollectionItemActions;
